import React from 'react';
import { Outlet, useLocation, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ErrorBoundary from '@lib/components/ErrorBoundary/ErrorBoundary';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import Typography from '@lib/components/Typography/Typography';
import Trans from '@lib/components/Trans/Trans';
import ReleaseTracker from '@lib/components/ReleaseTracker/ReleaseTracker';
import styles from './AccountLockedLayout.module.scss';

const {
  VITE_PLATFORM_URL: domain,
  VITE_RELEASE_VERSION: releaseVersion,
  VITE_RELEASE_TRACKER_SECONDS: releaseTrackerSeconds,
  MODE: mode,
  // @ts-ignore
} = import.meta.env;

interface Props {
  captureException: (error: Error, response?: unknown) => void;
  loginUrl: string;
}

function AccountLockedLayout(props: Props): React.ReactElement {
  const { loginUrl, captureException } = props;
  const { t } = useTranslation();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';

  return (
    <>
      <ReleaseTracker
        captureException={captureException}
        domain={domain}
        releaseVersion={releaseVersion}
        releaseTrackerSeconds={releaseTrackerSeconds}
        mode={mode}
      />
      <div className={styles.root}>
        <div className={styles.wrap}>
          <div className={styles.header}>
            <Button
              buttonText={t('back-to-log-in')}
              buttonType={ButtonTypes.quaternaryOutlined}
              to={loginUrl}
              leftIcon="arrow_back"
            />
            <Typography variant="h1">{t('account-locked-title')}</Typography>
            <Typography variant="body">
              <Trans i18nKey="account-locked-description" values={{ email }} />
            </Typography>
          </div>
          <div className={styles.body}>
            <ErrorBoundary
              location={location}
              captureException={captureException}
            >
              <Outlet />
            </ErrorBoundary>
          </div>
        </div>
      </div>
    </>
  );
}

export default AccountLockedLayout;
